<div class="client-select-wrapper">
  <label for="client-filter" class="p3">Tenant/Brand</label>
  <div class="clr-select-wrapper">
    <select id="client-filter" name="client-filter" class="clr-select" [formControl]="control">
      <option disabled value="">Select a client</option>
      <option [selected]="user.selectedClient.id === client.id" *ngFor="let client of user?.clients" [ngValue]="client">{{client.name}}</option>
    </select>
  </div>
</div>
